import { Service } from "typedi";
import { ScriptHostLocator } from "../../shared/utils/ScriptHostLocator";
import { IScriptOriginPublisher } from "./IScriptOriginPublisher";
import { IScriptOriginStream } from "./IScriptOriginStream";

const urlsToIgnore = [
  // URL of JS V1: we know that some merchants left the old import in their code, which appears before
  // the V3 import. If we do not ignore this, then the script origin tagger logic would say that our V3
  // script was downloaded from here
  "https://webservices.securetrading.net/js",
];

@Service()
export class ScriptOriginPublisher implements IScriptOriginPublisher {
  constructor(private stream: IScriptOriginStream) {}

  private filter(urlArray: string[]): string[] {
    return urlArray.filter((url) => !urlsToIgnore.includes(url));
  }

  findThenPublish(
    scripts: HTMLCollectionOf<HTMLScriptElement>,
    scriptName: string,
  ) {
    const baseUrls: string[] = this.filter(
      ScriptHostLocator.getScriptHosts(scripts, scriptName),
    );

    this.stream.push(baseUrls[0] ?? null);
  }
}
